import React, { Component, Fragment } from "react"

import Menu from "./Menu/Menu"
import MobileHeader from "./MobileHeader/MobileHeader"
import Home from "./Home/Home"
import Beers from "./Beers/Beers"
import Brasseries from "./Brasseries/Brasseries"
import Stores from "./Stores/Stores"
import Contact from "./Contact/Contact"
import Footer from "./Footer/Footer"
import Actu from "./Actu/Actu"
import Spinner from "react-spinkit"

import "./App.css"

class App extends Component {
  constructor() {
    super()
    this.state = {
      home: [],
      beers: [],
      brasseries: [],
      currentItem: "",
      actuIsOpen: false,
      shouldScroll: false,
    }
    this.handleNavMobile = this.handleNavMobile.bind(this)
  }

  componentDidMount() {
    const dataHome =
      "http://brasseriedubaigneur.com/wp-json/wp/v2/home?_embed&per_page=100"
    const dataBeer =
      "http://brasseriedubaigneur.com/wp-json/wp/v2/beer?_embed&per_page=100"
    const dataBrasserie =
      "http://brasseriedubaigneur.com/wp-json/wp/v2/brasserie?_embed&per_page=100"
    fetch(dataHome)
      .then(res => res.json())
      .then(res => {
        this.setState({
          home: res,
        })
      })
    fetch(dataBeer)
      .then(res => res.json())
      .then(res => {
        this.setState({
          beers: res,
        })
      })
    fetch(dataBrasserie)
      .then(res => res.json())
      .then(res => {
        this.setState({
          brasseries: res,
        })
      })
  }

  handleNavMobile(item) {
    this.setState({ currentItem: item })
  }

  onClickActu = () => {
    this.setState({
      actuIsOpen: !this.state.actuIsOpen,
    })
  }

  smoothScroll = hash => {
    const id = hash.replace("#", "")
    const $anchor = document.getElementById(id)
    const offsetTop = $anchor.getBoundingClientRect().top + window.pageYOffset
    window.scroll({
      top: offsetTop - 65,
      behavior: "smooth",
    })
    this.setState({ shouldScroll: false })
  }

  componentDidUpdate() {
    if (!!this.state.home.length && this.state.shouldScroll) {
      this.smoothScroll(this.state.hash)
    }
  }

  componentWillMount() {
    const { hash } = document.location
    if (hash !== "") {
      this.setState({ shouldScroll: true, hash })
    }
  }

  render() {
    const isMobile = window.innerWidth < 768
    const dataReady = !!this.state.home.length
    const wrapperClassName = this.state.actuIsOpen
      ? "site-wrapper active"
      : "site-wrapper"
    return (
      <Fragment>
        {isMobile && (
          <MobileHeader
            currentItem={this.state.currentItem}
            onClick={this.handleNavMobile}
          />
        )}
        {!isMobile && (
          <Menu
            onClickActu={this.onClickActu}
            isActive={this.state.actuIsOpen}
          />
        )}
        <div className={wrapperClassName}>
          {dataReady && (
            <Fragment>
              <Actu />
              <Home content={this.state.home} />
              <Brasseries brasseries={this.state.brasseries} />
              <Beers beers={this.state.beers} />
              <Stores />
              <Contact />
            </Fragment>
          )}
          {!dataReady && (
            <div className="page-container">
              <Spinner name="circle" color="#003e66" fadeIn="half" />
            </div>
          )}
        </div>
        <Footer />
      </Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/Components/App.js